import React from 'react';

import {PlaceholderWrapperComponent} from "../../../../core/components/placeholder/placeholder-wrapper";
import classNames from "classnames";
import styles from "../../styles/entity-scores-widget-placeholder.module.scss"

export const EntityScoresWidgetSectionHeaderPlaceholder = () => {
  return (
    <PlaceholderWrapperComponent className={classNames(styles.header_container)}>
      <div className={classNames(styles.content)}>
        <div className={classNames(styles.stage)}/>
        <div className={classNames(styles.date)}/>
      </div>
    </PlaceholderWrapperComponent>
  )
}
